import { findOrganization, organizationEntityName } from '../../../../../../backend/features/organizations/shared';
import { requireAnySystemPermission, requireOrgPermission } from '../../../../../../backend/features/permissions/shared';
import { useUserState } from '../../../../../../ui/hooks';
import { useInvalidateState } from '../../../../../../ui/hooks/deprecated/useInvalidateState';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { ModalSlideout } from '@juvare/common-web-ui/ModalSlideout';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OrganizationDetails } from './OrganizationDetails';
export const OrganizationSlideout = ({ orgId, onClose }) => {
    const userState = useUserState();
    const admin = requireOrgPermission(userState, orgId, 'manage-organization');
    const organizationTreeItem = orgId ? findOrganization(userState.organizations, orgId) : undefined;
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const { invalidateState } = useInvalidateState();
    let orgIdToGet;
    if (admin || (organizationTreeItem === null || organizationTreeItem === void 0 ? void 0 : organizationTreeItem.visible) || requireAnySystemPermission(userState, 'view-invisible-organizations')) {
        orgIdToGet = orgId;
    }
    const { data, isLoading, mutate: fetchOrg } = useStorageGet(organizationEntityName, orgIdToGet);
    if (isLoading || !orgId || !data) {
        return null;
    }
    return (React.createElement(ModalSlideout, { open: !!orgId, onClose: () => {
            onClose();
        }, "data-test": 'organization-slideout' },
        React.createElement(Box, { sx: {
                overflow: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: themeColors.surface.primary,
            }, "data-test": 'organization-details' },
            React.createElement(OrganizationDetails, { organization: data, onReload: () => {
                    invalidateState()
                        .then(() => fetchOrg())
                        .catch(handleErrorDialog);
                }, onClose: (reload) => {
                    onClose();
                    if (reload) {
                        invalidateState().catch(handleErrorDialog);
                    }
                }, onEditSection: () => undefined, onHistorySection: () => {
                    navigationContext.navigate(() => navigate({
                        pathname: orgId + '/history',
                    }, { state: { back: true } }));
                } }))));
};
